const CupScorersPageReducer = (state, action) => {
  switch (action.type) {
    case 'CUP_SCORERS_META_CUP_UPDATE':
      return {...state, metaCup: action.data};
    case 'CUP_SCORERS_FETCHING':
      return {...state, isFetching: true};
    case 'CUP_SCORERS_UPDATE':
      const CupScorersPage = {...state};
      CupScorersPage.scorers = CupScorersPage.scorers.concat(action.data.scorers);
      CupScorersPage.nextUrl = action.data.nextUrl;
      CupScorersPage.isFetching = false;
      return CupScorersPage;
    case 'CUP_SCORERS_ERROR':
      return {...state, error: action.data, isFetching: false};
    default:
      return state;
  }
};

export {CupScorersPageReducer};
